export const anaSponsorlar = [
  {
    id: 1,
    name: "Adeka İlaç",
    imageUrl: "/assets/sponsorlar/ana/adeka.png",
    url: "https://adeka.com.tr/"
  },
  {
    id: 1,
    name: "Akdağ Su",
    imageUrl: "/assets/sponsorlar/ana/akdag.png",
    url: "https://www.akdagsu.com.tr/"
  },
  {
    id: 2,
    name: "Altaş Grup",
    imageUrl: "/assets/sponsorlar/ana/altas.png",
    url: "https://www.altas.com.tr/"
  },
  {
    id: 2,
    name: "Asçelik",
    imageUrl: "/assets/sponsorlar/ana/ascelik.png",
    url: "https://www.ascelik.com/tr/"
  },
  {
    id: 3,
    name: "Atasam",
    imageUrl: "/assets/sponsorlar/ana/atasam.png",
    url: "https://www.atasamgrup.com/"
  },
  {
    id: 4,
    name: "Demir İnşaat Mimarlık",
    imageUrl: "/assets/sponsorlar/ana/demir.png",
    url: "https://www.grupdemir.com/"
  },
  {
    id: 4,
    name: "Duduoğlu",
    imageUrl: "/assets/sponsorlar/ana/duduoglu.png",
    url: "https://www.duduoglu.com.tr/"
  },
  {
    id: 5,
    name: "Düelsan",
    imageUrl: "/assets/sponsorlar/ana/duelsan.png",
    url: "http://www.duelsan.com.tr/Giris/Anasayfa"
  },
  {
    id: 6,
    name: "FKK Güney Oto Lastik Takoz",
    imageUrl: "/assets/sponsorlar/ana/fkk.png",
    url: "https://www.fkk.com.tr/"
  },
  {
    id: 7,
    name: "Köktaşlar",
    imageUrl: "/assets/sponsorlar/ana/koktas.png",
    url: "https://www.koktasgrup.com/"
  },
  {
    id: 7,
    name: "Mekanas",
    imageUrl: "/assets/sponsorlar/ana/makenas.png",
    url: "#"
  },
  {
    id: 8,
    name: "Otat",
    imageUrl: "/assets/sponsorlar/ana/otat.png",
    url: "https://www.otat.com.tr/"
  },
  {
    id: 9,
    name: "Sampa Otomotiv",
    imageUrl: "/assets/sponsorlar/ana/sampa.png",
    url: "https://www.sampa.com/tr"
  },
  {
    id: 10,
    name: "Samsun Yurt Savunma",
    imageUrl: "/assets/sponsorlar/ana/sys.png",
    url: "https://www.sysavunma.com/"
  },
  {
    id: 11,
    name: "Türk Hava Yolları",
    imageUrl: "/assets/sponsorlar/ana/turkish-airlines.png",
    url: "https://www.turkishairlines.com/"
  },
  {
    id: 11,
    name: "Ulusoy Un",
    imageUrl: "/assets/sponsorlar/ana/ulusoy.png",
    url: "https://ulusoyun.com.tr/"
  },
  {
    id: 12,
    name: "Yedaş",
    imageUrl: "/assets/sponsorlar/ana/yedas.png",
    url: "https://www.yedas.com/"
  },
  {
    id: 12,
    name: "Yeşilyurt",
    imageUrl: "/assets/sponsorlar/ana/yesilyurt.png",
    url: "https://www.yesilyurtdc.com.tr/"
  },
]